import { globalStyle, style } from '@vanilla-extract/css';

export const modalDialogContent = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'stretch',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      height: 'auto',
      maxHeight: '90vh',
      overflowY: 'auto',
    },
  },
});

export const modalContentContainer = style({
  display: 'flex',
  margin: '0 auto',
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      maxWidth: '100%',
      position: 'initial',
    },
  },
});

globalStyle(`${modalContentContainer}::-webkit-scrollbar`, {
  display: 'none',
});

globalStyle(`${modalDialogContent}::-webkit-scrollbar`, {
  display: 'none',
});
